import { generatePath } from 'react-router-dom'
import {
  PAYMENT_INFO,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestPaymentInfo = async (id) => {
  const path = generatePath(PAYMENT_INFO, { id })
  return request.get(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
